import { ESMenu, ESMenuItem } from '@energy-stacks/core/ui';
import { useTranslation } from 'react-i18next';
import { useRefreshConfiguration21 } from './useRefreshConfiguration21';

export const ConfigurationMenu21 = () => {
  const { t } = useTranslation('chargingStations');

  const retrieveConfiguration = useRefreshConfiguration21();

  return (
    <>
      <ESMenu testId={'configurationMenuItems'}>
        <ESMenuItem
          testId={'retrieveConfigurationMenuItem'}
          onClick={() => retrieveConfiguration()}
        >
          {t('retrieveConfiguration')}
        </ESMenuItem>
      </ESMenu>
    </>
  );
};
